import React, {Component} from 'react';
import './style.css';
import {connect} from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Alert} from "react-bootstrap";

class MyAnnuityPayments extends Component {

    static contextTypes = { api: PropTypes.object };


    renderPayment  = (payment)=>(
        <div className='col-lg-4 col-md-6 payment-col' key={payment.id}>
            <div className='payment-card'>
                <p className='annuity'>{payment.year}</p>
                <p>Pagado el {moment(payment.paymentDate).format('DD/MM/YYYY')}</p>

                {payment.files && payment.files.length?
                    <div className='files-cont'>
                        Recibos y facturas:<br/>
                        {payment.files.map( file=>(
                            <a href={this.context.api.appFiles.getUrl(file.id)} target='_blank' rel="noreferrer" key={file.id}>{file.originalName} <br/></a>
                        ))}
                    </div>
                    :null
                }
            </div>
        </div>
    );

    render(){

        const payments = this.props.me.person && this.props.me.person.membership? this.props.me.person.membership.annuityPayments:null;
        const currentYear = 2020;//moment().format('YYYY');


        const membershipPayments = _.filter(payments, (p)=>{return p.type==='membership'});
        const isActualMembershipPayed = _.filter(membershipPayments, (p)=>{return p.year === currentYear}).length!==0;

        const ihsPayments = _.filter(payments, (p)=>{return p.type==='ihs'});


        return(
            <div className="MembershipAnnuityPayments container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <div className="card-body">
                                <h2 className="card-title">Pagos de anualidades de miembro</h2>
                                {!isActualMembershipPayed?
                                    <Alert bsStyle='danger'>Estimado miembro, el pago del año {currentYear} no ha sido realizado.</Alert>:null
                                }
                                <div className='container-fluid'>
                                    <div className='row'>
                                        { !membershipPayments || !membershipPayments.length?
                                            <div className='alert text-center'>No se encontró ningún pago.</div>
                                            :
                                            membershipPayments.map( (payment)=>this.renderPayment(payment))
                                        }

                                    </div>
                                </div>
                            </div>

                            <div className="card-body">
                                <h2 className="card-title">Pagos de anualidades IHS</h2>

                                <div className='container-fluid'>
                                    <div className='row'>
                                        { !ihsPayments || !ihsPayments.length?
                                            <div className='alert text-center'>No se encontró ningún pago.</div>
                                            :
                                            ihsPayments.map( (payment)=>this.renderPayment(payment))
                                        }

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ( {api:{me={}}} )=>({me});

export default connect(mapStateToProps)(MyAnnuityPayments);



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/MyAnnuityPayments/index.jsx